import {SingleCarousel} from "./SingleCarousel"
export const Diseny = ()=>{
    return (
        <div>
           <SingleCarousel/> 
        </div>
    )
}